<template>
    <div>
        <Banner :banners="banners" show-overlay> </Banner>
        <Breadcrumb></Breadcrumb>
        <div class="info-wrapper default">
            <h2 class="title text-left d-flex">
                <img src="@/assets/event_ic_top.png" class="mr-2" alt="" /><span class="align-self-end">年度活動</span>
                <div class="align-self-end sub-title ml-auto">
                    <img src="@/assets/event_btn_l_arrow_n.png" alt="Previous" class="mr-2" style="cursor:pointer;" @click="yearChange(-1)" />
                    {{ paras.year }}
                    <img src="@/assets/event_btn_r_arrow_n.png" alt="Next" class="ml-2" style="cursor:pointer;" @click="yearChange(1)" />
                </div>
            </h2>
            <p class="text-sm"></p>
            <div class="search-wrapper pink mb-3">
                <div class="form-row row mb-2">
                    <div class="col-3">
                        <div
                            class="month-btn"
                            @click="toggleMonths([1, 2, 3])"
                            :class="{
                                active: paras.months.includes(1) && paras.months.includes(2) && paras.months.includes(3),
                            }"
                        >
                            1月~3月
                        </div>
                    </div>
                    <div class="col-3">
                        <div
                            class="month-btn"
                            @click="toggleMonths([4, 5, 6])"
                            :class="{
                                active: paras.months.includes(4) && paras.months.includes(5) && paras.months.includes(6),
                            }"
                        >
                            4月~6月
                        </div>
                    </div>
                    <div class="col-3">
                        <div
                            class="month-btn"
                            @click="toggleMonths([7, 8, 9])"
                            :class="{
                                active: paras.months.includes(7) && paras.months.includes(8) && paras.months.includes(9),
                            }"
                        >
                            7月~9月
                        </div>
                    </div>
                    <div class="col-3">
                        <div
                            class="month-btn"
                            @click="toggleMonths([10, 11, 12])"
                            :class="{
                                active: paras.months.includes(10) && paras.months.includes(11) && paras.months.includes(12),
                            }"
                        >
                            10月~12月
                        </div>
                    </div>
                </div>
                <div class="d-flex">
                    <div class="input-group mr-1">
                        <input type="text" class="form-control" placeholder="請輸入關鍵字" v-model="paras.keyword" @keyup.enter="query" />
                        <div class="input-group-append">
                            <button class="btn btn-search" @click="query">
                                <img src="@/assets/common_ic_enter_search.png" alt="search" />
                            </button>
                        </div>
                    </div>
                </div>
            </div>
            <Loader :show="loading"></Loader>
            <ul class="event-wrapper" v-show="!loading">
                <li class="item">
                    <div class="item-header">1月~3月</div>
                    <ul>
                        <li v-for="event in seasonOneEvent" :key="event.id">
                            <a href="" @click.prevent="goDetail(event.id)">
                                <div class="event-list-card">
                                    <div class="img-wrapper">
                                        <vue-load-image>
                                            <img slot="image" :src="`${apiPhotoUrl}/ori/${event.photoId}`" :alt="event.name" />
                                            <img slot="preloader" src="@/assets/image-loader.gif" class="w-100" />
                                            <img slot="error" class="border d-block" src="" alt="not found" />
                                        </vue-load-image>
                                    </div>
                                    <div class="card-body d-flex flex-column justify-content-center">
                                        <div class="title" v-text="event.name">
                                            筏子溪科普親子體驗營 泡泡糖╳清潔液DIY樂
                                        </div>
                                        <div class="time align-self-baseline" v-text="`${dateConvert(event.startDate, 'YYYY-MM-DD')} ~ ${dateConvert(event.endDate, 'YYYY-MM-DD')}`">
                                            2022-02-01 ~ 2022-02-28
                                        </div>
                                    </div>
                                </div>
                            </a>
                        </li>
                    </ul>
                </li>
                <li class="item">
                    <div class="item-header">4月~6月</div>
                    <ul>
                        <li v-for="event in seasonTwoEvent" :key="event.id">
                            <a href="" @click.prevent="goDetail(event.id)">
                                <div class="event-list-card">
                                    <div class="img-wrapper">
                                        <vue-load-image>
                                            <img slot="image" :src="`${apiPhotoUrl}/ori/${event.photoId}`" :alt="event.name" />
                                            <img slot="preloader" src="@/assets/image-loader.gif" class="w-100" />
                                            <img slot="error" class="border d-block" src="" alt="not found" />
                                        </vue-load-image>
                                    </div>
                                    <div class="card-body d-flex flex-column justify-content-center">
                                        <div class="title" v-text="event.name">
                                            筏子溪科普親子體驗營 泡泡糖╳清潔液DIY樂
                                        </div>
                                        <div class="time align-self-baseline" v-text="`${dateConvert(event.startDate, 'YYYY-MM-DD')} ~ ${dateConvert(event.endDate, 'YYYY-MM-DD')}`">
                                            2022-02-01 ~ 2022-02-28
                                        </div>
                                    </div>
                                </div>
                            </a>
                        </li>
                    </ul>
                </li>
                <li class="item">
                    <div class="item-header">7月~9月</div>
                    <ul>
                        <li v-for="event in seasonThreeEvent" :key="event.id">
                            <a href="" @click.prevent="goDetail(event.id)">
                                <div class="event-list-card">
                                    <div class="img-wrapper">
                                        <vue-load-image>
                                            <img slot="image" :src="`${apiPhotoUrl}/ori/${event.photoId}`" :alt="event.name" />
                                            <img slot="preloader" src="@/assets/image-loader.gif" class="w-100" />
                                            <img slot="error" class="border d-block" src="" alt="not found" />
                                        </vue-load-image>
                                    </div>
                                    <div class="card-body d-flex flex-column justify-content-center">
                                        <div class="title" v-text="event.name">
                                            筏子溪科普親子體驗營 泡泡糖╳清潔液DIY樂
                                        </div>
                                        <div class="time align-self-baseline" v-text="`${dateConvert(event.startDate, 'YYYY-MM-DD')} ~ ${dateConvert(event.endDate, 'YYYY-MM-DD')}`">
                                            2022-02-01 ~ 2022-02-28
                                        </div>
                                    </div>
                                </div>
                            </a>
                        </li>
                    </ul>
                </li>
                <li class="item">
                    <div class="item-header">10月~12月</div>
                    <ul>
                        <li v-for="event in seasonFourEvent" :key="event.id">
                            <a href="" @click.prevent="goDetail(event.id)">
                                <div class="event-list-card">
                                    <div class="img-wrapper">
                                        <vue-load-image>
                                            <img slot="image" :src="`${apiPhotoUrl}/ori/${event.photoId}`" :alt="event.name" />
                                            <img slot="preloader" src="@/assets/image-loader.gif" class="w-100" />
                                            <img slot="error" class="border d-block" src="" alt="not found" />
                                        </vue-load-image>
                                    </div>
                                    <div class="card-body d-flex flex-column justify-content-center">
                                        <div class="title" v-text="event.name">
                                            筏子溪科普親子體驗營 泡泡糖╳清潔液DIY樂
                                        </div>
                                        <div class="time align-self-baseline" v-text="`${dateConvert(event.startDate, 'YYYY-MM-DD')} ~ ${dateConvert(event.endDate, 'YYYY-MM-DD')}`">
                                            2022-02-01 ~ 2022-02-28
                                        </div>
                                    </div>
                                </div>
                            </a>
                        </li>
                    </ul>
                </li>
            </ul>
        </div>
    </div>
</template>

<script>
/* eslint-disable global-require */
import Banner from '@/components/shared/Banner';
import Breadcrumb from '@/components/Breadcrumb';
import Loader from '@/components/Loader';
import coreMixin from '@/js/mixin/coreMixin';
import { apiEvents } from '@/plugin/api';

export default {
    data() {
        return {
            banners: [
                {
                    linkUrl: require('@/assets/banner_news.jpg'),
                },
            ],
            searchFilterShow: false,
            paras: {
                year: new Date().getFullYear(),
                months: [],
                keyword: '',
            },
            eventList: [],
            loading: false,
        };
    },
    mounted() {
        this.query();
    },
    computed: {
        seasonOneEvent() {
            return this.eventList.filter((event) => {
                const monthTotal = this.monthTotal(event.startDate, event.endDate);
                return monthTotal.includes(`${this.paras.year}-01`) || monthTotal.includes(`${this.paras.year}-02`) || monthTotal.includes(`${this.paras.year}-03`);
            });
        },
        seasonTwoEvent() {
            return this.eventList.filter((event) => {
                const monthTotal = this.monthTotal(event.startDate, event.endDate);
                return monthTotal.includes(`${this.paras.year}-04`) || monthTotal.includes(`${this.paras.year}-05`) || monthTotal.includes(`${this.paras.year}-06`);
            });
        },
        seasonThreeEvent() {
            return this.eventList.filter((event) => {
                const monthTotal = this.monthTotal(event.startDate, event.endDate);
                return monthTotal.includes(`${this.paras.year}-07`) || monthTotal.includes(`${this.paras.year}-08`) || monthTotal.includes(`${this.paras.year}-09`);
            });
        },
        seasonFourEvent() {
            return this.eventList.filter((event) => {
                const monthTotal = this.monthTotal(event.startDate, event.endDate);
                return monthTotal.includes(`${this.paras.year}-10`) || monthTotal.includes(`${this.paras.year}-11`) || monthTotal.includes(`${this.paras.year}-12`);
            });
        },
    },
    methods: {
        goDetail(id) {
            this.$router.push(`${this.$route.path}/${id}`);
        },
        async getOpenApiEvents() {
            this.loading = true;
            await apiEvents(this.paras).then((res) => {
                if (res.data.success) {
                    // eslint-disable-next-line arrow-parens
                    this.eventList = res.data.data.map(item => ({
                        ...item,
                        lat: +item.latitude,
                        lon: +item.longitude,
                        name: item.subject,
                        id: item.eventId,
                    })).sort((a, b) => new Date(b.startDate) - new Date(a.startDate));
                }
            }, this.errorHandler);
            this.loading = false;
        },
        query() {
            this.getOpenApiEvents();
        },
        yearChange(step) {
            this.paras.year += step;
            this.clear();
            this.query();
        },
        clear() {
            this.paras.months = [];
            this.paras.keyword = '';
        },
        monthCount(d1, d2) {
            const startDate = new Date(d1);
            const endDate = new Date(d2);
            const monthCount = (endDate.getFullYear() - startDate.getFullYear()) * 12 - startDate.getMonth() + endDate.getMonth() + 1;
            return monthCount;
        },
        monthTotal(d1, d2) {
            const startDate = new Date(d1);
            return Array.from({ length: this.monthCount(d1, d2) }).map((_, index) => {
                const date = new Date(startDate.getFullYear(), startDate.getMonth(), 1);
                date.setMonth(date.getMonth() + index);
                return this.dateConvert(date, 'YYYY-MM');
            });
        },
        toggleMonths(months) {
            months.forEach((month) => {
                if (this.paras.months.includes(month)) {
                    this.paras.months.splice(this.paras.months.indexOf(month), 1);
                } else {
                    this.paras.months.push(month);
                }
            });
            this.query();
        },
    },
    components: {
        Banner,
        Breadcrumb,
        Loader,
    },
    mixins: [coreMixin],
};
</script>

<style></style>
